$(document).ready(function() {


    // Function to check if a section is in the viewport
    function isScrolledIntoView(elem) {
        var docViewTop = $(window).scrollTop();
        var docViewBottom = docViewTop + $(window).height();
        var elemTop = $(elem).offset().top;
        var elemBottom = elemTop + $(elem).height();
        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    }

    // Add class 'active' to specific section when it's reached
    $(window).scroll(function() {

if($('body').hasClass('template-product')){
var get_top = $(".product-single__form").offset().top - 50; 
   var showAfterc = topcart;
 if ($(this).scrollTop() > get_top ) { 
   $(".add_to_cart_wrap").addClass('visible');
  }else{
   $(".add_to_cart_wrap").removeClass('visible');

} 

}else{
          var topcart =$(".custom_our_guarantee").offset().top - 100; 
var get_top = $(".custom_custom_scroll_start").offset().top + 400; 
   var showAfterc = topcart;
  if ($(this).scrollTop() > get_top ) { 
   $(".add_to_cart_wrap").addClass('visible');
  }else{
   $(".add_to_cart_wrap").removeClass('visible');

} 
  if ($(this).scrollTop() > showAfterc ) { 
   $(".add_to_cart_wrap").removeClass('visible');
  } else { 
 //  $(".add_to_cart_wrap").addClass('visible');
  }



        var section1 = $('.jt-heading');
        var section2 = $('.custom_our_guarantee');

if ($(this).scrollTop() < 10 ) {
$(".add_to_cart_wrap").removeClass('visible');
}
}
    });



$(".2-pack .variant-input").eq(1).find('label').trigger('click');
    // $('form[action="/cart/add"]').submit(function(e) {
    //   e.preventDefault();
    //   var $form = $(this);

    //   $.ajax({
    //     type: $form.attr('method'),
    //     url: $form.attr('action'),
    //     data: $form.serialize(),
    //     success: function() {
    //       window.location.href = '/checkout';
    //     }
    //   });
    // });
  });


$(".variant-input").click(function(){
  var $this = $(this);
  setTimeout(function() {
    var get_price = $(".product-single__form select.product-single__variants.no-js option:selected").attr('data-price');
    var get_quantity = parseInt($this.parents('.product-single__meta').find(".js-qty__wrapper input.js-qty__num").val());
    var get_price_updated = get_price * get_quantity;
    
    $("span.product_price").html(window.theme.Currency.formatMoney(get_price_updated));
 }, 100);
});
$(".js-qty__adjust").click(function(){
  var $this = $(this);
  setTimeout(function() {  
    //var get_price = $("select.product-single__variants.no-js option:selected").attr('data-price');
    var get_price = $(".product-single__form select.product-single__variants.no-js option:selected").attr('data-price');
    var get_quantity = parseInt($this.parent().find("input.js-qty__num").val()); 
    var get_price_updated = get_price * get_quantity; 
    
    $("span.product_price").html(window.theme.Currency.formatMoney(get_price_updated));
   }, 100);
});

$(document).on('click','.add_to_cart_button button',function(e){ 
    e.preventDefault();
    e.stopPropagation();
$(this).addClass('btn--loading');
var ID = $(this).attr("data-id"); 
$.ajax({
type: 'POST',
url: '/cart/add.js',
data: {
  quantity: 1,
  id: ID
},
  dataType: 'json', 
 success: function (data) { 
console.log('sucess');
$(".add_to_cart_button button").removeClass('btn--loading');
$('.drawer.drawer--right.drawer--is-open').animate({scrollTop: 0}, 100);
$('.drawer__scrollable').animate({scrollTop: 0}, 100);
$(".upsell_product_wrap").hide();
     document.dispatchEvent(new CustomEvent('cart:build'));

 
 } 
 });
});

$(document).on('click','.cart__remove',function(e){ 
  // debugger
   var lineItemId = $(this).attr('data-id');
var get_upsell = $(".upsell_pdp").val();
if(lineItemId == get_upsell){
$(".upsell_product_wrap").show();
}
$(this).addClass('btn--loading');
var $this = $(this);
                var data = {
                    'id': lineItemId,
                    'quantity': '0'
                };
                    $.ajax({
                    type: 'POST',
                    url: '/cart/change.js',
                    data: data,
                    dataType: 'json',
                    success: function(response) {
      $this.addClass('btn--loading');
     document.dispatchEvent(new CustomEvent('cart:build'));
shippingProtection();
                        console.log('Item removed from cart');
                        // You can handle success response here
                    },
                    error: function(XMLHttpRequest, textStatus, errorThrown) {
                        console.log('Error occurred while removing item from cart');
                        // You can handle error here
                    }
                });
  });
$(".add_to_cart_button").click(function(){
if($('body').hasClass('template-product')){
 // $('html, body').animate({
 //        scrollTop: $(".product-single__form").offset().top-200
 //    }, 500);
$("form.product-single__form button.btn.btn--full.add-to-cart").trigger('click');
}else{
 $('html, body').animate({
        scrollTop: $(".product__photos").offset().top
    }, 1000);
}
});

$(document).ready(function(){
  shippingProtection();
  if (window.location.href.includes('/cart')) {
    shippingProtection();
  }
});
$('button.add-to-cart').click(function(){
  var counter = 0;
  var FreeCounter = 0;
  var interval = setInterval(function() {
    counter++;
    if($("button.add-to-cart").length) {
      shippingProtection();
      clearInterval(interval);
    }
    if(counter > 10 ) {
      clearInterval(interval);
    }
  }, 2000);
});
function shippingProtection() {
  var variantID = shippingProtectionProductVariantID;
  console.log("**************variantID**********************" , variantID)
  var motivatorProduct = false;
  $.ajax({
    type: 'GET',
    url: '/cart.json',
    dataType: 'jsonp',
    success: function(data) {
      var items = data['items'];
      console.log("==================items" , items)
      var itemsValue = data['items_subtotal_price'];
      for (var i = 0; i < items.length; i++) {
        if (items[i]["id"] == shippingProtectionProductVariantID) {
          motivatorProduct = true;
          $(".click_gift").prop("checked", true);
        }
      }
      console.log("motivatorProduct" , motivatorProduct)
      if(items.length === 1){
        if(motivatorProduct) {
          removeShippingProtectionProduct(variantID);
          console.log('items.length === 1')
        }
      }
      if(items.length > 0){
        if(!motivatorProduct && !getTheCookie("Shipping_protection") ) {
          addShippingProtectionProduct(variantID);
          console.log('items.length > 0')
        }
      
      } else {
        removeShippingProtectionProduct(variantID);
        console.log('! items.length > 0')
      }
    }
  });
}
function addShippingProtectionProduct(variantID) {
  var cartDrawer = document.querySelector('cart-drawer');
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: 1,
      id: variantID
    },
    dataType: 'json', 
    success: function (data) { 
      console.log('successfully added shipping protection product');
      setTheCookie("Shipping_protection", true)
      document.dispatchEvent(new CustomEvent('cart:build'));
      $(".click_gift").prop("checked", true);
     } 
  });
}

function removeShippingProtectionProduct(variantID) {
  $('#CartDrawer-Checkout').attr('disabled',true)
  var data = {
    'id': variantID,
    'quantity': '0'
  };
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: data,
    dataType: 'json',
    success: function(response) {
      document.dispatchEvent(new CustomEvent('cart:build'));
      getTheCookie("Shipping_protection");
      console.log("get cookie value on product delete" , getTheCookie("Shipping_protection"))
      if(getTheCookie("Shipping_protection") == "true" ) {
        console.log("remove cookie");
        $(".click_gift").prop("checked", false);
        eraseTheCookie("Shipping_protection")
      }
      // eraseTheCookie("Shipping_protection")
      console.log('successfully removed shipping protection product');
    },
    error: function(XMLHttpRequest, textStatus, errorThrown) {
      
      console.log('Error occurred while removing item from cart');
    }
  });
}

function setTheCookie(name,value,days) {
  var expires = "";
  if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
    
function getTheCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
function eraseTheCookie(name) {   
  document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

$('#toggleSwitch').click(function() {
  var isChecked = $(this).prop('checked');
  if (isChecked) {
    console.log("Checkbox is checked");
    addShippingProtectionProduct(shippingProtectionProductVariantID);
  } else {
    console.log("Checkbox is unchecked");
    setTheCookie("Shipping_protection", "false")
    removeShippingProtectionProduct(shippingProtectionProductVariantID);
  }
});